import { useEffect, useState } from 'react';
import { finanzasService } from '../services/api';
import '../styles/Gastos.css';

const Gastos = () => {
  const [gastos, setGastos] = useState([]);
  const [tiposEgresos, setTiposEgresos] = useState([]);
  const [suplidores, setSuplidores] = useState([]);
  const [bancos, setBancos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editingGasto, setEditingGasto] = useState(null);
  const [filtros, setFiltros] = useState({
    fecha_desde: '',
    fecha_hasta: '',
    tipo_egreso_id: '',
    suplidor_id: '',
    aprobado: ''
  });
  const [formData, setFormData] = useState({
    fecha: new Date().toISOString().split('T')[0],
    concepto: '',
    monto: '',
    tipo_egreso_id: '',
    suplidor_id: '',
    banco_id: '',
    referencia: '',
    ncf: '',
    detalle: ''
  });
  const [stats, setStats] = useState({
    total_gastos: 0,
    pendientes_aprobacion: 0,
    gastos_mes: 0
  });

  useEffect(() => {
    cargarDatos();
  }, []);

  useEffect(() => {
    cargarGastos();
  }, [filtros]);

  const cargarDatos = async () => {
    try {
      setLoading(true);
      const [tiposRes, suplidoresRes, bancosRes, statsRes] = await Promise.all([
        finanzasService.getTiposEgresos(),
        finanzasService.getSuplidores(),
        finanzasService.getBancos(),
        finanzasService.getDashboardFinanzas()
      ]);

      setTiposEgresos(tiposRes.data.tipos_egresos || []);
      setSuplidores(suplidoresRes.data.suplidores || []);
      setBancos(bancosRes.data.bancos || []);
      setStats({
        total_gastos: statsRes.data.gastos_mes || 0,
        pendientes_aprobacion: statsRes.data.gastos_pendientes || 0,
        gastos_mes: statsRes.data.gastos_mes || 0
      });

      await cargarGastos();
    } catch (error) {
      console.error('Error al cargar datos:', error);
      alert('Error al cargar los datos');
    } finally {
      setLoading(false);
    }
  };

  const cargarGastos = async () => {
    try {
      const response = await finanzasService.getGastos({
        ...filtros,
        per_page: 50
      });
      setGastos(response.data.gastos || []);
    } catch (error) {
      console.error('Error al cargar gastos:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingGasto) {
        await finanzasService.updateGasto(editingGasto.id, formData);
        alert('Gasto actualizado exitosamente');
      } else {
        await finanzasService.createGasto(formData);
        alert('Gasto creado exitosamente');
      }

      setShowForm(false);
      setEditingGasto(null);
      resetForm();
      await cargarGastos();
      await cargarStats();
    } catch (error) {
      console.error('Error al guardar gasto:', error);
      alert('Error al guardar el gasto');
    }
  };

  const handleEdit = (gasto) => {
    setEditingGasto(gasto);
    setFormData({
      fecha: gasto.fecha,
      concepto: gasto.concepto,
      monto: gasto.monto,
      tipo_egreso_id: gasto.tipo_egreso_id,
      suplidor_id: gasto.suplidor_id || '',
      banco_id: gasto.banco_id || '',
      referencia: gasto.referencia || '',
      ncf: gasto.ncf || '',
      detalle: gasto.detalle || ''
    });
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('¿Está seguro de eliminar este gasto?')) {
      try {
        await finanzasService.deleteGasto(id);
        alert('Gasto eliminado exitosamente');
        await cargarGastos();
        await cargarStats();
      } catch (error) {
        console.error('Error al eliminar gasto:', error);
        alert('Error al eliminar el gasto');
      }
    }
  };

  const handleAprobar = async (id) => {
    if (window.confirm('¿Está seguro de aprobar este gasto?')) {
      try {
        await finanzasService.aprobarGasto(id);
        alert('Gasto aprobado exitosamente');
        await cargarGastos();
        await cargarStats();
      } catch (error) {
        console.error('Error al aprobar gasto:', error);
        alert('Error al aprobar el gasto');
      }
    }
  };

  const resetForm = () => {
    setFormData({
      fecha: new Date().toISOString().split('T')[0],
      concepto: '',
      monto: '',
      tipo_egreso_id: '',
      suplidor_id: '',
      banco_id: '',
      referencia: '',
      ncf: '',
      detalle: ''
    });
  };

  const cargarStats = async () => {
    try {
      const response = await finanzasService.getDashboardFinanzas();
      setStats({
        total_gastos: response.data.gastos_mes || 0,
        pendientes_aprobacion: response.data.gastos_pendientes || 0,
        gastos_mes: response.data.gastos_mes || 0
      });
    } catch (error) {
      console.error('Error al cargar estadísticas:', error);
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading">Cargando gastos...</div>
      </div>
    );
  }

  return (
    <div className="gastos-container">
      <div className="gastos-header">
        <h1>💰 Gestión de Gastos</h1>
        <button
          className="btn-primary"
          onClick={() => {
            setShowForm(true);
            setEditingGasto(null);
            resetForm();
          }}
        >
          + Nuevo Gasto
        </button>
      </div>

      {/* Estadísticas */}
      <div className="stats-container">
        <div className="stat-card">
          <h3>Gastos del Mes</h3>
          <p className="stat-value">RD$ {stats.gastos_mes.toLocaleString()}</p>
        </div>
        <div className="stat-card">
          <h3>Pendientes de Aprobación</h3>
          <p className="stat-value">{stats.pendientes_aprobacion}</p>
        </div>
      </div>

      {/* Filtros */}
      <div className="filtros-container">
        <div className="filtro-group">
          <label>Fecha Desde:</label>
          <input
            type="date"
            value={filtros.fecha_desde}
            onChange={(e) => setFiltros({...filtros, fecha_desde: e.target.value})}
          />
        </div>
        <div className="filtro-group">
          <label>Fecha Hasta:</label>
          <input
            type="date"
            value={filtros.fecha_hasta}
            onChange={(e) => setFiltros({...filtros, fecha_hasta: e.target.value})}
          />
        </div>
        <div className="filtro-group">
          <label>Tipo de Egreso:</label>
          <select
            value={filtros.tipo_egreso_id}
            onChange={(e) => setFiltros({...filtros, tipo_egreso_id: e.target.value})}
          >
            <option value="">Todos</option>
            {tiposEgresos.map(tipo => (
              <option key={tipo.id} value={tipo.id}>{tipo.nombre}</option>
            ))}
          </select>
        </div>
        <div className="filtro-group">
          <label>Estado:</label>
          <select
            value={filtros.aprobado}
            onChange={(e) => setFiltros({...filtros, aprobado: e.target.value})}
          >
            <option value="">Todos</option>
            <option value="true">Aprobados</option>
            <option value="false">Pendientes</option>
          </select>
        </div>
        <button
          className="btn-secondary"
          onClick={() => setFiltros({
            fecha_desde: '',
            fecha_hasta: '',
            tipo_egreso_id: '',
            suplidor_id: '',
            aprobado: ''
          })}
        >
          Limpiar Filtros
        </button>
      </div>

      {/* Modal de Formulario */}
      {showForm && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header">
              <h2>{editingGasto ? 'Editar Gasto' : 'Nuevo Gasto'}</h2>
              <button
                className="btn-close"
                onClick={() => setShowForm(false)}
              >
                ×
              </button>
            </div>

            <form onSubmit={handleSubmit} className="gasto-form">
              <div className="form-row">
                <div className="form-group">
                  <label>Fecha *</label>
                  <input
                    type="date"
                    value={formData.fecha}
                    onChange={(e) => setFormData({...formData, fecha: e.target.value})}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Monto *</label>
                  <input
                    type="number"
                    step="0.01"
                    value={formData.monto}
                    onChange={(e) => setFormData({...formData, monto: e.target.value})}
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <label>Concepto *</label>
                <input
                  type="text"
                  value={formData.concepto}
                  onChange={(e) => setFormData({...formData, concepto: e.target.value})}
                  required
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Tipo de Egreso *</label>
                  <select
                    value={formData.tipo_egreso_id}
                    onChange={(e) => setFormData({...formData, tipo_egreso_id: e.target.value})}
                    required
                  >
                    <option value="">Seleccionar...</option>
                    {tiposEgresos.map(tipo => (
                      <option key={tipo.id} value={tipo.id}>{tipo.nombre}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <label>Suplidor</label>
                  <select
                    value={formData.suplidor_id}
                    onChange={(e) => setFormData({...formData, suplidor_id: e.target.value})}
                  >
                    <option value="">Seleccionar...</option>
                    {suplidores.map(suplidor => (
                      <option key={suplidor.id} value={suplidor.id}>{suplidor.nombre}</option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Banco/Cuenta</label>
                  <select
                    value={formData.banco_id}
                    onChange={(e) => setFormData({...formData, banco_id: e.target.value})}
                  >
                    <option value="">Seleccionar...</option>
                    {bancos.map(banco => (
                      <option key={banco.id} value={banco.id}>{banco.nombre}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <label>Referencia</label>
                  <input
                    type="text"
                    value={formData.referencia}
                    onChange={(e) => setFormData({...formData, referencia: e.target.value})}
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>NCF</label>
                  <input
                    type="text"
                    value={formData.ncf}
                    onChange={(e) => setFormData({...formData, ncf: e.target.value})}
                  />
                </div>
              </div>

              <div className="form-group">
                <label>Detalle</label>
                <textarea
                  value={formData.detalle}
                  onChange={(e) => setFormData({...formData, detalle: e.target.value})}
                  rows="3"
                />
              </div>

              <div className="form-actions">
                <button type="button" className="btn-secondary" onClick={() => setShowForm(false)}>
                  Cancelar
                </button>
                <button type="submit" className="btn-primary">
                  {editingGasto ? 'Actualizar' : 'Guardar'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Tabla de Gastos */}
      <div className="gastos-table-container">
        <table className="gastos-table">
          <thead>
            <tr>
              <th>Fecha</th>
              <th>Concepto</th>
              <th>Tipo</th>
              <th>Monto</th>
              <th>Suplidor</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {gastos.map(gasto => (
              <tr key={gasto.id}>
                <td>{new Date(gasto.fecha).toLocaleDateString()}</td>
                <td>{gasto.concepto}</td>
                <td>{gasto.tipo_egreso?.nombre}</td>
                <td>RD$ {gasto.monto.toLocaleString()}</td>
                <td>{gasto.suplidor?.nombre || 'N/A'}</td>
                <td>
                  <span className={`estado ${gasto.aprobado ? 'aprobado' : 'pendiente'}`}>
                    {gasto.aprobado ? 'Aprobado' : 'Pendiente'}
                  </span>
                </td>
                <td className="acciones">
                  {!gasto.aprobado && (
                    <>
                      <button
                        className="btn-edit"
                        onClick={() => handleEdit(gasto)}
                        title="Editar"
                      >
                        ✏️
                      </button>
                      <button
                        className="btn-delete"
                        onClick={() => handleDelete(gasto.id)}
                        title="Eliminar"
                      >
                        🗑️
                      </button>
                      <button
                        className="btn-approve"
                        onClick={() => handleAprobar(gasto.id)}
                        title="Aprobar"
                      >
                        ✅
                      </button>
                    </>
                  )}
                  {gasto.aprobado && (
                    <span className="texto-muted">Aprobado</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {gastos.length === 0 && (
          <div className="no-data">
            <p>No hay gastos registrados</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Gastos;